import { DataProvider } from 'react-admin'
import { EngineMediaActionDto } from '../../dto/engine-media/engine-media-action.dto'

const fakeFiles: EngineMediaActionDto[] = []

const provider = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getList: (resource, params) =>
    Promise.resolve({ data: fakeFiles, total: fakeFiles.length }),
} as DataProvider

export default provider
